// extracted by mini-css-extract-plugin
export default {"pageContent":"styles_pageContent__SGho3","modemAnimation":"styles_modemAnimation__WwVkl","path1":"styles_path1__81Gm0","path2":"styles_path2__n1SaL","path3":"styles_path3__iInSm"};